<template>
  <div class="myinfo">
    <h1><span></span>提交论文</h1>
    <div class="answer-teacher">
      <ul class="answer-content">
        <li class="row">
          <ul class="message">
            <li>
            <div class="col-md-6">
              <div class="author">我:</div>
              <div class="link"><router-link to="">我的论文名称我的论文名称</router-link> <button class="btn btn-default">下载<i class="iconfont icon-arrow-down"></i></button></div>
              <div class="answermsg">
                <span class="answers1">回复：</span>论文题目论文题目dddd论文题目论文题目dddd提供高薪兼职，是境外间谍机构诱骗我境内人员的惯用手法。今年4月，一名自称姓叶的女子，联系来辽宁大连务工的赵某兼职拍照，提供日薪200元待遇。由于想赚快钱，赵某在叶某的遥控指挥下，到港口>
              </div>
              <div class="date">2020-10-22</div>
            </div>
          </li>
            <li>
              <div class="col-md-6">
                <div class="author">我:</div>
                <div class="link"><router-link to="">我的论文名称我的论文名称</router-link> <button class="btn btn-default">下载<i class="iconfont icon-arrow-down"></i></button></div>
                <div class="answermsg">
                  <span class="answers1">回复：</span>论文题目论文题目dddd论文题目论文题目dddd提供高薪兼职，是境外间谍机构诱骗我境内人员的惯用手法。今年4月，一名自称姓叶的女子，联系来辽宁大连务工的赵某兼职拍照，提供日薪200元待遇。由于想赚快钱，赵某在叶某的遥控指挥下，到港口
                </div>
                <div class="date">2020-10-22</div>
              </div>
            </li>
          </ul>
          <ul class="message">
            <li class="row">
                <div class="offset-6 col-md-6">
                  <div class="author"> <div class="pull-right"> <span  class="teacher">李雪琴</span>回复:</div> </div>
                  <div class="margin-bottom-20"></div>
                  <div class="link"><div class="pull-right"><router-link to="">我的论文名称我的论文名称</router-link> <button class="btn btn-default">下载<i class="iconfont icon-arrow-down"></i></button></div><div class="clearfix"></div></div>
                  <div class="answermsg">
                    <span class="answers1">回复：</span>论文题目论文题目dddd论文题目论文题目dddd提供高薪兼职，是境外间谍机构诱骗我境内人员的惯用手法。今年4月，一名自称姓叶的女子，联系来辽宁大连务工的赵某兼职拍照，提供日薪200元待遇。由于想赚快钱，赵某在叶某的遥控指挥下，到港口
                  </div>
                  <div class="date">2020-10-22</div>
                </div>>
            </li>
            <li class="row">
              <div class="offset-6 col-md-6">
                <div class="author "> <div class="pull-right"> <span  class="teacher">李雪琴</span>回复:</div> </div>
                <div class="margin-bottom-20"></div>
                <div class="link margin-top-20"><div class="pull-right"><router-link to="">我的论文名称我的论文名称</router-link> <button class="btn btn-default">下载<i class="iconfont icon-arrow-down"></i></button></div><div class="clearfix"></div></div>
                <div class="answermsg">
                  <span class="answers1">回复：</span>论文题目论文题目dddd论文题目论文题目dddd提供高薪兼职，是境外间谍机构诱骗我境内人员的惯用手法。今年4月，一名自称姓叶的女子，联系来辽宁大连务工的赵某兼职拍照，提供日薪200元待遇。由于想赚快钱，赵某在叶某的遥控指挥下，到港口
                </div>
                <div class="date"><div class="pull-right">2020-10-22</div><div class="clearfix"></div></div>
              </div>
            </li>
          </ul>
        </li>
      </ul>
      <div class="row">
        <div class="col-md-6">
        </div>
        <div class="col-md-6"></div>
      </div>
    </div>
    <div class="answer-teacher">
      <form class="form-horizontal">
        <div class="form-group row">
          <label class="col-md-1 control-label">题目</label>
          <div class="col-md-11">
            论文题目论文题目 论文题目论文题目 论文题目论文题目
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-1 control-label">论文</label>
          <div class="col-md-11">
            <button class="btn btn-load"><i class="iconfont icon-wenjianshangchuan1"></i>
              <div>点击此处上传论文</div>
            </button>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-1 control-label">备注</label>
          <div class="col-md-11"><textarea rows="5" class="form-control"></textarea>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-1 control-label">&nbsp;&nbsp;&nbsp;&nbsp;</label>
          <div class="col-md-11">
            <button type="submit" class="btn btn-default btn-sub">提交</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'ViewState',
    data: function () {
      return {}
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/mixins.styl'
  .myinfo {
    background: #fff;
    margin-top: 20px;
  }

  .btn-load {
    padding: 30px 200px;
    border: 1px solid #ced4da;
    color: #ced4da;
    background: #fff;
    i {
      font-size: 30px;
      color: #ced4da;
    }
  }

  .btn-sub {
    padding: 6px 16px;
    background: $bgColor;
    color: #fff;
  }

  .answers {
    background: $bgcontent;
    padding: 30px;
    .col-md-1 {
      padding-right: 0;
    }
  }

  .answer-teacher {
    background: #fbfbfb;
    padding: 20px;
    margin-top: 20px;
  }

  h1 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    span {
      display: inline-block;
      width: 4px;
      height: 16px;
      background: $bgColor;
      margin-right: 10px;
      position: relative;
      top: 2px;
    }
  }

  textarea {
    background: #fff;
  }
  .author{
    font-weight: bold;
    margin-bottom:20px;
  }
  .message{
    padding-right:20px;
    li{
      margin-bottom:20px;
    }
    .link{
      font-size:16px;
      margin-bottom:15px;
      .btn{
        border:1px solid #f4a84b;
        font-size:13px;
        color:#f4a84b;
        padding:0px 4px;
        border-radius:20px;
        i{
          font-size:10px;
          margin-left:5px;
        }
      }
    }
  }
  .answermsg{
    color:#9a9a9a;
    line-height:24px;
    background:#f7f6f6;
    border-radius:10px;
    padding:15px;
    .answers1{
      font-weight:bold;
      color: #a09a9a;
      margin-bottom:10px;
    }
  }
  .date{
    color:#b1afaf;
    font-size:14px;
    margin-top:10px;
  }
  .answer-content{
    background:#fff;
    margin:10px;
    padding:20px;
  }
  .teacher{
    color:$bgColor;
    margin-right:10px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/graduationmanagement/components/ChangeStateThird.vue